import React, {useContext, useRef, useState} from "react";
import {Button, Spinner} from "react-bootstrap";
import SearchBox from "../../../component/global/SearchBox";
import IconBox from "../../../component/global/IconBox";
import {post} from "../../../controlers/global/ConfigRequest";
import {getBase64Arr} from "../../../controlers/global/getBase64";
import {ToastContext} from "../../../component/global/ToastContext";
import {FEEDBACK_STATUS_ASSIGN} from "../../../helperData/ApiAddress";
import "../style.scss";
import {useTranslation} from "react-i18next";

export default function Sharing({
                                  feedbackStatusId,
                                  assignGroups,
                                  setAssignGroups,
                                  setMessageModalTabs,
                                }) {
  const show = useContext(ToastContext);

  const [search, setSearch] = useState("");
  const [check, setCheck] = useState(true);
  const [description, setDescription] = useState("");
  const [file, setFile] = useState();
  const [group, setGroup] = useState();
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(false);
  const [fileError, setFileError] = useState();
  const fileInput = useRef();
  const {t} = useTranslation();

  const getFileHandle = (e) => {
    let files = e.currentTarget.files[0];

    if (files?.size?.toString() > 2024 * 2024) {
      setFileError(t("Src.Pages.Messages.Modals.Sharing.Size.Err"));
      setFile("");
      return false;
    } else {
      setFileError("");
      getBase64Arr(e).then((r) => {
        setFile(r[0]);
      });
    }
  };

  const HandleCheckBox = (index, g) => {
    index = index + "";
    if (index.substr(0, 2) === "u-") {
      setGroup(g);
      setUser(index.substr(2) * 1);
      setCheck(index);
    } else {
      setGroup(index * 1);
      setUser(null);
      setCheck(index * 1);
    }
  };

  const assignHandle = () => {
    setLoading(true);
    post(FEEDBACK_STATUS_ASSIGN.replace("{id}", feedbackStatusId), {
      group,
      user,
      file,
      description,
    })
      .then((r) => {
        setAssignGroups([]);
        setMessageModalTabs("commentDetails");
        show(
          t("Src.Pages.Messages.Modals.Sharing.Send.Success"),
          "success",
          t("Src.Pages.Messages.Modals.Sharing.Send.Success.Flag")
        );
      })
      .catch((e) => {
        show(
          t("Src.Pages.Messages.Modals.Sharing.Send.Danger"),
          "danger",
          t("Src.Pages.Messages.Modals.Sharing.Send.Danger.Flag")
        );
      })
      .finally((_) => setLoading(false));
  };

  return (
    <div className="sharing_content modal_main_content">
      <div>
        <div className="messages_content_filter">
          <SearchBox
            spacialClass="table_serach"
            value={search}
            changeFunction={(e) => setSearch(e)}
          />
        </div>
        <div className="modal_card_main sharing-card-main">
          <div className="right-section">
            {(() => {
              if (assignGroups?.length > 0) {
                let has = false;
                let mapped = assignGroups.map((r) => {
                  if (r.name.indexOf(search) >= 0) has = true;
                  return (
                    <React.Fragment key={r.id}>
                      {r.name.indexOf(search) >= 0 && (
                        <div
                          className="share_card"
                          onClick={() =>
                            HandleCheckBox(r.id)
                          }
                        >
                          <div
                            className={
                              "share_card_main" +
                              (check === r.id
                                ? " active"
                                : "")
                            }
                          >
                            <div className="share_card_info">
                              <div className="check_btn">
                                <div
                                  className={
                                    check ===
                                    r.id
                                      ? "selected"
                                      : ""
                                  }
                                >
                                  <div></div>
                                </div>
                              </div>
                              <div className="share_group_st">
                                  <span>
                                      {t(
                                        "Organizational.Messages.Group.Label"
                                      )}
                                  </span>
                                <span>
                                    {r.name}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      <div>
                        {r.members.map((q) => {
                          if (
                            q.username.indexOf(
                              search
                            ) >= 0 ||
                            q.workplace?.indexOf(
                              search
                            ) >= 0
                          )
                            has = true;
                          return (
                            (q.username.indexOf(
                                search
                              ) >= 0 ||
                              q.workplace?.indexOf(
                                search
                              ) >= 0) && (
                              <div
                                className="share_card"
                                key={
                                  "u-" + q.id
                                }
                                onClick={() =>
                                  HandleCheckBox(
                                    "u-" + q.id,
                                    r.id
                                  )
                                }
                              >
                                <div
                                  className={
                                    "share_card_main users-card-con" +
                                    (check ===
                                    "u-" + q.id
                                      ? " active"
                                      : "")
                                  }
                                >
                                  <div className="share_card_info ">
                                    <div className="check_btn">
                                      <div
                                        className={
                                          check ===
                                          "u-" +
                                            q.id
                                            ? "selected"
                                            : ""
                                        }
                                      >
                                        <div></div>
                                      </div>
                                    </div>
                                    <div className="share_group_st">
                                      <div className="user-info-con">
                                          <span>
                                              {t(
                                                "Organizational.Messages.Username.Label"
                                              )}
                                          </span>
                                        <span>
                                            {q.username}
                                        </span>
                                      </div>
                                      <div className="user-info-con">
                                          <span>
                                              {t(
                                                "Organizational.Messages.Level.Label"
                                              )}
                                          </span>
                                        <span>
                                            {q.role || "-"}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          );
                        })}
                      </div>
                    </React.Fragment>
                  );
                });
                return has ? (
                  mapped
                ) : (
                  <span dir="rtl">
                      {t("Organizational.Messages.Not.Found")}
                  </span>
                );
              } else {
                return (
                  <span dir="rtl">
                      {t("Organizational.Messages.Loading")}
                  </span>
                );
              }
            })()}
          </div>
          <div className="left-section">
              <textarea value={description} onChange={(e) => setDescription(e.target.value)}>
              </textarea>
            <div className="sharing-buttons ">
              <label className={"sharing-send-file " + (file ? " selected" : "")}>
                <IconBox iconName="attachIcon"/>
                {fileError ? (
                  <span
                    style={{
                      color: "red",
                      textAlign: "right",
                      fontSize: "11px",
                    }}
                  >
                      {fileError}
                  </span>
                ) : (t("Organizational.Messages.Upload.File.Label"))}
                <input
                  type="file"
                  onChange={getFileHandle}
                  ref={fileInput}
                />
              </label>
              {file && (
                <Button
                  onClick={(_) => {
                    setFile("");
                    fileInput.current.value = "";
                  }}
                  className="form_btn medium"
                  style={{
                    width: 80,
                    backgroundColor: "white",
                    border: "none",
                    outline: "none",
                    color: "#666",
                    fontSize: 12,
                  }}
                >
                  {t(
                    "Organizational.Messages.Remove.File.Label"
                  )}
                </Button>
              )}
              <Button
                disabled={
                  !(group || user) ||
                  description.trim() === "" ||
                  loading
                }
                onClick={assignHandle}
                className="form_btn medium blue"
              >
                {loading ? (
                  <Spinner animation="border"/>
                ) : (
                  <span>
                      {t(
                        "Organizational.Messages.Send.Label"
                      )}
                  </span>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
